import find from 'lodash-es/find';
import { storefrontAccessToken, storefrontAccessTokenDev } from '../config';

const getGraphIDFromProductId = (product_id) => {
  return `gid://shopify/Product/${product_id}`;
};

const getShopifyProductsForCountry = async (graph_product_ids) => {
  let storefront_access_token = storefrontAccessTokenDev;
  if (window.Shopify.shop === 'windsor-us.myshopify.com') {
    storefront_access_token = storefrontAccessToken;
  }

  const body = JSON.stringify({ query: `query products @inContext(country: ${window.theme.country_iso}) { nodes(ids: ["${graph_product_ids.join('","')}"]) { ... on Product { id, priceRange {maxVariantPrice { amount currencyCode }, minVariantPrice { amount currencyCode }}, variants(first: 100) { edges { node { id, availableForSale, selectedOptions { name value}, barcode, title, image { url }, compareAtPrice { amount currencyCode }, quantityAvailable , price { amount currencyCode } } } } } } }` });


  const response = await window.fetch(`https://${window.Shopify.shop}/api/2023-07/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefront_access_token,
    },
    body,
  });

  const object = await response.json();

  if (!object || !object.data) {
    throw new Error(`No products found in Shopify for this certona ids: ${graph_product_ids}`);
  }

  const shopify_products = [];
  for (const product of object.data.nodes) {
    if (!product || !product.variants) {
      continue;
    }
    const variants = [];
    for (const variant_node of product.variants.edges) {
      variants.push(variant_node.node);
    }
    product.variants = variants;
    shopify_products.push(product);
  }
  return shopify_products;
};

const updateFastSimonProductsPricesByCountry = async (items) => {
  const graph_product_ids = items.map((item) => {
    return getGraphIDFromProductId(item.id);
  });

  try {
    const shopify_products = await getShopifyProductsForCountry(graph_product_ids);

    const final_items_list = [];
    for (const product of shopify_products) {
      if (!product.variants) {
        console.error(`No variants found in Shopify for this product: ${product.id}`);
        continue;
      }
      const product_id_parts = product.id.split('/');
      const product_id = product_id_parts[product_id_parts.length - 1];
      const fast_simon_product = find(items, {
        id: product_id,
      });
      if (!fast_simon_product) {
        continue;
      }

      let max_price = 0;
      let min_price = 999999;
      let max_compare_price = 0;
      let min_compare_price = 999999;
      for (const variant of product.variants) {
        const variant_id_parts = variant.id.split('/');
        const variant_id = variant_id_parts[variant_id_parts.length - 1];
        for (const fast_simon_variant of fast_simon_product.vra) {
          if (fast_simon_variant[0] === Number(variant_id)) {
            if (variant.price && Number(variant.price.amount) > max_price && variant.availableForSale) {
              max_price = Number(variant.price.amount);
            }
            if (variant.price && Number(variant.price.amount) < min_price && variant.availableForSale) {
              min_price = Number(variant.price.amount);
            }
            if (
              variant.compareAtPrice &&
              Number(variant.compareAtPrice.amount) > max_compare_price &&
              variant.availableForSale
            ) {
              max_compare_price = Number(variant.compareAtPrice.amount);
            }
            if (
              variant.compareAtPrice &&
              Number(variant.compareAtPrice.amount) < min_compare_price &&
              variant.availableForSale
            ) {
              min_compare_price = Number(variant.compareAtPrice.amount);
            }
            for (const attributes of fast_simon_variant[1]) {
              if (attributes[0] === 'Price') {
                attributes[1] = [`${variant.price.currencyCode}:${Number(variant.price.amount).toFixed(2)}`];
              }
            }
            break;
          }
        }
      }
      fast_simon_product.p = min_price.toFixed(2);
      fast_simon_product.p_max = max_price.toFixed(2);
      fast_simon_product.p_min = min_price.toFixed(2);
      fast_simon_product.p_c = min_price.toFixed(2);
      fast_simon_product.p_max_c = max_compare_price.toFixed(2);
      fast_simon_product.p_min_c = min_compare_price.toFixed(2);
      fast_simon_product.c = product.priceRange.minVariantPrice.currencyCode;
      final_items_list.push(fast_simon_product);
    }

    return final_items_list;
  } catch (error) {
    console.error(error);
  }
};

export { getGraphIDFromProductId, getShopifyProductsForCountry, updateFastSimonProductsPricesByCountry };
